import {classNames, Fragment, observer, React} from '@api'
import {CatalogItemSidebarDetailsLoader} from '@lazy'
import {CatalogItemsList, CatalogLibraries, StoresInstanceContext, useStores} from '@modules'
import {CatalogRootFlexLayoutStoreContext, globalStores} from '@stores'
import {computed} from 'mobx'
import * as css from './CatalogLibrariesFlexLayout.css'

export const CatalogLibrariesFlexLayout = observer(function CatalogLibrariesFlexLayout() {
  const {flexLayout: {activeOrLastCatalogRoot, activeTab}} = globalStores,
    {catalog, sidebar: {left: {associatedWorkspace, selectedTab, selectedLibrary, selectedCatalogFieldLibrary, selectedLibraryConfig, selectedPathItem}}} = activeOrLastCatalogRoot?.storesToInject ?? activeTab?.vipTabStore?.toolWindowStoresToInject ?? globalStores,
    view = selectedPathItem?.where ? 'details' : (selectedLibrary || selectedCatalogFieldLibrary) ? 'library-items' : 'libraries',
    stores = activeOrLastCatalogRoot?.storesToInject ?? activeTab.storesToInject

  return (
    <CatalogRootFlexLayoutStoreContext.Provider value={activeOrLastCatalogRoot}>
      <StoresInstanceContext.Provider value={stores}>
        <div className={css.root} data-view={view}>
          {!stores
           ? null
           : (!activeOrLastCatalogRoot?.tab && activeTab?.storesToInject?.purpose !== 'inline-details')
             ? <NoActiveCatalog/>
             : <Fragment
               key={activeOrLastCatalogRoot?.tab?.id} // Otherwise we can get stuck when we switch tabs with an out of data prior item
             >
               <CatalogLibraries align='left' key='libraries' className={css.catalogLibraries}/>

               <CatalogItemsList library={selectedLibrary}
                                 key={'library-items'}
                                 workspace={associatedWorkspace ?? catalog?.workspaceConfig}
                                 catalogField={selectedCatalogFieldLibrary}
                                 titleStyle='count'
                                 className={css.libraryItems}
                                 visible //={selectedTab === 'libraries' && (selectedLibraryConfig != null || selectedCatalogFieldLibrary) != null}
                                 align='left'/>

               <CatalogItemSidebarDetailsLoader align='left'
                                                key={`details-loader-${_.first<any>(selectedPathItem?.where)?.value}`}
                                                library={selectedLibraryConfig}
                                                className={css.details}
                                                where={selectedPathItem?.where}
                                                context={selectedPathItem?.sidebarContext}
                                                debugId={`CatalogLibrariesFlexLayout-${activeTab?.id}`}
               />
             </Fragment>
          }
        </div>
      </StoresInstanceContext.Provider>
    </CatalogRootFlexLayoutStoreContext.Provider>)
})

export const NoActiveCatalog = observer(function NoActiveCatalog() {
  const {strings} = useStores()
  return (<div className={css.blank}>
    {strings.intentionallyBlank}
  </div>)
})


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/toolbox-items/CatalogLibrariesFlexLayout.tsx